import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { __decorate } from "tslib";
import { Component, provide, createRef } from 'intact-vue-next';
import template from './base.vdt';
import { sizes } from '../../styles/utils';
import { SELECT } from './constants';
import { useShowHideEvents } from '../../hooks/useShowHideEvents';
import { bind } from '../utils';
import { Dropdown } from '../dropdown';
import { useInput } from './useInput';
import { useFocusout } from './useFocusout';
import { isNullOrUndefined } from 'intact-shared';
import { useDraggable } from './useDraggble';
import { useImmutable } from './useImmutable';
import { useConfigContext } from '../config';
var typeDefs = {
  value: null,
  multiple: Boolean,
  filterable: Boolean,
  loading: Boolean,
  disabled: Boolean,
  name: String,
  size: sizes,
  hideIcon: Boolean,
  clearable: Boolean,
  fluid: Boolean,
  inline: Boolean,
  placeholder: [String, Number],
  container: [Function, String],
  width: [String, Number],
  show: Boolean,
  position: Dropdown.typeDefs.position,
  flat: Boolean,
  nowrap: Boolean,
  draggable: Boolean
};
var defaults = function defaults() {
  return {
    size: 'default'
  };
};
var events = {
  keydown: true,
  focusout: true,
  show: true,
  hide: true
};
export var BaseSelect = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BaseSelect, _Component);
  function BaseSelect() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.dropdownRef = createRef();
    _this.input = useInput(_this.resetKeywords);
    _this.focusout = useFocusout();
    _this.draggable = useDraggable();
    _this.immutable = useImmutable();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = BaseSelect.prototype;
  _proto.init = function init() {
    provide(SELECT, this);
    useShowHideEvents('show');
    this.watch('value', this.position, {
      presented: true
    });
  };
  _proto.position = function position() {
    var dropdown = this.dropdownRef.value;
    if (dropdown.get('value')) {
      do {
        dropdown.position();
      } while (dropdown = dropdown.showedDropdown);
    }
  };
  _proto.show = function show() {
    this.set('show', true);
  };
  _proto.hide = function hide() {
    this.set('show', false);
  };
  _proto.resetKeywords = function resetKeywords(keywords) {
    keywords.set('');
  };
  _proto.hasValue = function hasValue() {
    var _this$get = this.get(),
      value = _this$get.value,
      multiple = _this$get.multiple;
    return !isNullOrUndefined(value) && (multiple ? value.length : value !== '');
  };
  _proto.delete = function _delete(index, e) {
    var _context2;
    if (this.get('disabled')) return;
    e.stopPropagation();
    var value = _sliceInstanceProperty(_context2 = this.get('value')).call(_context2, 0);
    _spliceInstanceProperty(value).call(value, index, 1);
    this.set('value', value);
  };
  _proto.clear = function clear(e) {
    e.stopPropagation();
    var _this$get2 = this.get(),
      value = _this$get2.value,
      multiple = _this$get2.multiple;
    var immutableValues = this.immutable.immutableValues.value;
    this.set('value', multiple ? Array.isArray(value) ? _filterInstanceProperty(value).call(value, function (key) {
      return _includesInstanceProperty(immutableValues).call(immutableValues, key);
    }) : [] : null);
  };
  _proto.onKeydown = function onKeydown(e) {
    this.trigger('keydown', e);
    switch (e.keyCode) {
      case 13:
        // enter
        this.show();
        break;
      case 9: // tab
      case 27:
        // esc
        this.hide();
        break;
    }
  };
  return BaseSelect;
}(Component);
// for intact-react, intact-vue-next and intact-vue
BaseSelect.$doubleVNodes = true;
BaseSelect.template = template;
BaseSelect.typeDefs = typeDefs;
BaseSelect.defaults = defaults;
BaseSelect.events = events;
__decorate([bind], BaseSelect.prototype, "position", null);
__decorate([bind], BaseSelect.prototype, "show", null);
__decorate([bind], BaseSelect.prototype, "hide", null);
__decorate([bind], BaseSelect.prototype, "clear", null);
__decorate([bind], BaseSelect.prototype, "onKeydown", null);